/* eslint-disable object-curly-newline */
import VueRouter from 'vue-router';

import URLSearchParams from 'url-search-params';
import store from './store';

import Login from './components/PageLogin';
import ForgotPassword from './components/PageForgotPassword';
import ResetPassword from './components/PageResetPassword';

import OpportunityList from './components/Opportunity/OpportunityList';
import OpportunityForm from './components/Opportunity/OpportunityForm';
import OpportunityPreview from './components/Opportunity/OpportunityPreview';
import OpportunityView from './components/Opportunity/OpportunityView';
import OpportunityShare from './components/Opportunity/OpportunityShare';

import MADDList from './components/MADD/MADDList';
import MADDForm from './components/MADD/MADDForm';
import MADDPreview from './components/MADD/MADDPreview';
import MADDView from './components/MADD/MADDView';

import IntelligenceList from './components/Intelligence/IntelligenceList';
import IntelligenceForm from './components/Intelligence/IntelligenceForm';
import IntelligencePreview from './components/Intelligence/IntelligencePreview';
import IntelligenceView from './components/Intelligence/IntelligenceView';

import InsightForm from './components/Insight/InsightForm';
import InsightList from './components/Insight/InsightList';
import InsightPreview from './components/Insight/InsightPreview';
import InsightView from './components/Insight/InsightView';
import InsightCategoryForm from './components/InsightCategory/InsightCategoryForm';

import MemberList from './components/Member/MemberList';
import MemberView from './components/Member/MemberView';
import MemberCreateForm from './components/Member/MemberCreateForm.vue';
import MemberEditForm from './components/Member/MemberEditForm.vue';

import UserList from './components/User/UserList';
import UserForm from './components/User/UserForm';
import UserView from './components/User/UserView';
import UserCreateForm from './components/User/UserCreateForm';
import UserImpersonate from './components/User/UserImpersonate';

import SectorSpecialists from './components/Sector/SectorSpecialists';
import SectorAdd from './components/Sector/SectorAdd'
import SectorEdit from '@components/Sector/SectorEdit';
import SectorEditAll from '@components/Sector/SectorEditAll';
import SectorLanding from '@components/Sector/SectorLanding';
import SectorSingleView from '@components/Sector/SectorSingleView';
import SectorPostView from "@components/Sector/Post/View";
import SectorPostEdit from "@components/Sector/Post/Edit";

import NotificationsView from "@components/Notifications/View";

import SearchPage from "./components/Search/Page";

import PageDashboard from './components/PageDashboard';
import PageEvent from './components/PageEvent';
import PageThanks from './components/PageThanks';

import DocumentRoot from '@components/Documents/DocumentsRoot';

import ConferencesRoot from '@components/Documents/Conferences/ConferencesRoot.vue';
import ConferenceDocumentList from '@components/Documents/Conferences/DocumentList';
import DocumentPreview from '@components/Documents/Conferences/DocumentPreview';
import DocumentFormPage from '@components/Documents/Conferences/DocumentFormPage';


import ReportList from './components/Report/ReportList';
import InsightCategoryDeleteForm from './components/InsightCategory/InsightCategoryDeleteForm';

import EventDashboard from './components/Events/EventDashboard';
import EventView from './components/Events/EventView';

import ActivityView from '@components/Activities/ActivityView';
import ActivityEdit from '@components/Activities/EditForm';

import EventForm from '@components/Events/EditForm';
import PageTitle from './resources/PageTitle';
import InsightCategoryEditForm from '@components/InsightCategory/InsightCategoryEditForm.vue';
import DocumentCategory from '@components/Documents/DocumentCategory.vue';
import PageSectorTree from '@components/PageSectorTree.vue';

const routes = [
	{
		path: '/login',
		component: Login,
		meta: { requiresLogin: false, requiresLogout: true },
		name: 'login',
		props: route => ({
			registration: route.query.registration,
		}),
	},
	{
		path: '/login/forgot-password',
		component: ForgotPassword,
		name: 'forgot-password',
		meta: { requiresLogin: false, requiresLogout: true },
	},
	{
		path: '/login/reset-password',
		component: ResetPassword,
		meta: { requiresLogin: false, requiresLogout: true },
		name: 'reset-password',
		props: () => ({
			token: new URLSearchParams(window.location.search).get('token'),
		}),
	},
	{
		path: '/dashboard/:tab?',
		component: PageDashboard,
		name: 'dashboard',
		props: route => ({
			tab: route.params.tab,
		}),
	},
	{
		path: '/account/:tab?',
		component: UserForm,
		name: 'account',
		props: route => ({
			tab: route.params.tab,
		}),
	},
    {
      path: '/sectors/tree',
      component: PageSectorTree,
      name: 'sectors-tree',
    },
	{
		path: '/search/:query?/:tab?',
		component: SearchPage,
		name: 'search',
		props: route => ({
			query: route.params.query ?? '',
			tab: route.params.tab ?? 'opportunities',
		}),
	},
    {
        path: '/events',
        component: EventDashboard,
        name: 'events'
    },
    {
        path: '/events/:event_id(\\d+)',
        component: EventView,
        name: 'view-event',
        props: route => ({
            id: parseInt(route.params.event_id),
        }),
    },
    // Activities
    {
        path: '/activities/:activity_id(\\d+)',
        component: ActivityView,
        name: 'view-activity',
        props: route => ({
            id: parseInt(route.params.activity_id),
        }),
    },
    {
      path: '/events/:event_id(\\d+)/activities/create',
      component: ActivityEdit,
      name: 'create-activity',
      props: route => ({
          eventId: parseInt(route.params.event_id),
          start: route.params.start ? route.params.start : null,
      })
    },
    // {
    //     path: '/activities/create',
    //     component: ActivityEdit,
    //     name: 'create-activity',
    // },
    {
        path: '/events/:event_id(\\d+)/activities/:activity_id(\\d+)/edit',
        component: ActivityEdit,
        name: 'edit-activity',
        props: route => ({
            eventId: parseInt(route.params.event_id),
            id: parseInt(route.params.activity_id),
        }),
    },
    {
        path: '/events/:event_id(\\d+)/edit',
        component: EventForm,
        name: 'edit-event',
        props: route => ({
            id: parseInt(route.params.event_id),
        }),
    },
    {
        path: '/events/create',
        component: EventForm,
        name: 'create-event',
    },

	//Members
	{
		path: '/members',
		component: MemberList,
		name: 'members'
	},
    {
        path: '/members/:id(\\d+)/edit',
        component: MemberEditForm,
        name: 'edit-member-form',
        props: route => ({
            id: parseInt(route.params.id),
            step: 1,
        }),
    },
	{
		path: '/members/:id(\\d+)/:tab?',
		component: MemberView,
		name: 'view-member',
		props: route => ({
			id: parseInt(route.params.id),
			tab: route.params.tab,
		}),
	},
	{
		path: '/members/create',
		component: MemberCreateForm,
		name: 'create-member'
	},
    {
        path: '/documents',
        component: DocumentRoot,
        name: 'documents'
    },
    {
        path: '/documents/category/:category_id(\\d+)',
        component: DocumentCategory,
        name: 'document-category',
        props: route => ({
            id: parseInt(route.params.category_id),
        })
    },
    {
        path: '/documents/categories/create',
        component: InsightCategoryForm,
        name: 'create-document-category'
    },
    {
        path: '/documents/categories/delete',
        component: InsightCategoryDeleteForm,
        name: 'delete-document-categories'
    },
    {
        path: '/documents/categories/:category_id(\\d+)/edit',
        component: InsightCategoryEditForm,
        name: 'edit-document-category',
        props: route => ({
            id: parseInt(route.params.category_id),
        }),
    },
    {
        path: '/documents/conferences',
        component: ConferencesRoot,
        name: 'conference-documents'
    },
    {
        path: '/documents/conferences/:event_id(\\d+)',
        component: ConferenceDocumentList,
        name: "conference-document-list",
        props: route => ({
            id: parseInt(route.params.event_id),
        })
    },
    {
        path: '/documents/conferences/:event_id(\\d+)/create',
        component: DocumentFormPage,
        name: 'create-conference-document',
        props: route => ({
            event_id: parseInt(route.params.event_id),
        })
    },
    {
        path: '/documents/conferences/:event_id(\\d+)/document/:document_id(\\d+)/preview',
        component: DocumentPreview,
        name: "preview-conference-document",
        props: route => ({
            id: parseInt(route.params.document_id),
            event_id: parseInt(route.params.event_id),
        })
    },
    {
        path: '/documents/conferences/:event_id(\\d+)/document/:document_id(\\d+)/edit',
        component: DocumentFormPage,
        name: "edit-conference-document",
        props: route => ({
            event_id: parseInt(route.params.event_id),
            id: parseInt(route.params.document_id),
        })
    },
    {
        path: '/documents/(sector|list)/:tab?',
		component: InsightList,
        name: "sector-documents",
        props: route => ({
            type: 2,
            pageTitle: "Sector Documents",
			tab: route.params.tab,
            hideCategory: true,
            backLink: true,
        })
    },
    {
        path: '/documents/marketing-materials/:tab?',
		component: InsightList,
        name: "marketing-documents",
        props: route => ({
            type: 308,
            pageTitle: "Marketing Materials",
			tab: route.params.tab,
            hideCategory: true,
            backLink: true,
        })
    },
    {
        path: '/documents/:insight_id(\\d+)',
        component: InsightView,
        name: 'view-document',
        props: route => ({
            id: parseInt(route.params.insight_id),
        }),
    },
    {
        path: '/documents/create',
        component: InsightForm,
        name: 'create-document'
    },

    {
        path: '/documents/create/:step([1-3])',
        component: InsightForm,
        name: 'create-document-step',
        props: route => ({ step: parseInt(route.params.step) }),
    },
    {
        path: '/documents/:insight_id(\\d+)/edit/:step([1-3])',
        component: InsightForm,
        name: 'edit-document-step',
        props: route => ({
            step: parseInt(route.params.step),
            id: parseInt(route.params.insight_id),
        }),
    },
    {
        path: '/documents/:insight_id(\\d+)/preview',
        component: InsightPreview,
        name: 'preview-document',
        props: route => ({
            id: parseInt(route.params.insight_id),
        }),
    },

    {
        path: '/insights/:tab?',
        component: InsightList,
        name: 'insights',
        props: route => ({
            tab: route.params.tab,
        }),
    },

	{
		path: '/members/create/:step([1-5])',
		component: MemberCreateForm,
		name: 'create-member-step',
		props: route => ({ step: parseInt(route.params.step) }),
	},
	//MADDS
	{
		path: '/madds/:madd_id(\\d+)',
		component: MADDView,
		name: 'view-madd',
		props: route => ({
			id: parseInt(route.params.madd_id),
		}),
	},
	{
		path: '/madds/create',
		component: MADDForm,
		name: 'create-madd',
		props: { step: 1 },
	},
	{
		path: '/madds/create/:step([1-4])',
		component: MADDForm,
		name: 'create-madd-step',
		props: route => ({ step: parseInt(route.params.step) }),
	},
	{
		path: '/madds/:madd_id(\\d+)/edit/:step([1-4])',
		component: MADDForm,
		name: 'edit-madd-step',
		props: route => ({
			step: parseInt(route.params.step),
			id: parseInt(route.params.madd_id),
		}),
	},
	{
		path: '/madds/:madd_id(\\d+)/preview',
		component: MADDPreview,
		name: 'madd-preview',
		props: route => ({
			id: parseInt(route.params.madd_id),
		}),
	},
	{
		path: '/madds/:tab?',
		component: MADDList,
		name: 'madds',
		props: route => ({
			tab: route.params.tab,
		}),
	},

	//Opportunities
	{
		path: '/opportunities/:opportunity_id(\\d+)',
		component: OpportunityView,
		name: 'view-opportunity',
		props: route => ({
			id: parseInt(route.params.opportunity_id),
		}),
	},
	{
		path: '/opportunities/:opportunity_id(\\d+)/responses/:response_id(\\d+)',
		component: OpportunityView,
		name: 'view-opportunity-response',
		props: route => ({
			id: parseInt(route.params.opportunity_id),
			responseId: parseInt(route.params.response_id),
		}),
	},
	{
		path: '/opportunities/create',
		component: OpportunityForm,
		name: 'create-opportunity',
	},
	{
		path: '/opportunities/create/:step([1-5])',
		component: OpportunityForm,
		name: 'create-opportunity-step',
		props: route => ({ step: parseInt(route.params.step) }),
	},
	{
		path: '/opportunities/:opportunity_id(\\d+)/edit/:step([1-5])',
		component: OpportunityForm,
		name: 'edit-opportunity-step',
		props: route => ({
			step: parseInt(route.params.step),
			id: parseInt(route.params.opportunity_id),
		}),
	},
	{
		path: '/opportunities/:opportunity_id(\\d+)/preview',
		component: OpportunityPreview,
		name: 'opportunity-preview',
		props: route => ({
			id: parseInt(route.params.opportunity_id),
		}),
	},
	{
		path: '/opportunities/:opportunity_id(\\d+)/share',
		component: OpportunityShare,
		name: 'share-opportunity',
		props: route => ({
			id: parseInt(route.params.opportunity_id),
		}),
	},
	{
		path: '/opportunities/:tab?',
		component: OpportunityList,
		name: 'opportunities',
		props: route => ({
			tab: route.params.tab,
		}),
	},

	//Intelligence
	{
		path: '/intelligence/:intelligence_id(\\d+)',
		component: IntelligenceView,
		name: 'view-intelligence',
		props: route => ({
			id: parseInt(route.params.intelligence_id),
		}),
	},
	{
		path: '/intelligence/create',
		component: IntelligenceForm,
		name: 'create-intelligence',
	},
	{
		path: '/intelligence/:intelligence_id(\\d+)/edit',
		component: IntelligenceForm,
		name: 'edit-intelligence',
		props: route => ({
			id: parseInt(route.params.intelligence_id),
		}),
	},
	{
		path: '/intelligence/:intelligence_id(\\d+)/preview',
		component: IntelligencePreview,
		name: 'intelligence-preview',
		props: route => ({
			id: parseInt(route.params.intelligence_id),
		}),
	},
	{
		path: '/intelligence/:tab?',
		component: IntelligenceList,
		name: 'intelligence',
		props: route => ({
			tab: route.params.tab,
		}),
	},
	{
		path: '/user/:user_id(\\d+)/edit/:tab?',
		component: UserForm,
		name: 'edit-user',
		props: route => ({
			id: parseInt(route.params.user_id),
			tab: route.params.tab,
		}),
	},
	{
		path: '/user/:user_id(\\d+)/:tab?',
		component: UserView,
		name: 'view-user',
		props: route => ({
			id: parseInt(route.params.user_id),
			tab: route.params.tab,
		}),
	},
	{
		path: '/sectors',
		component: SectorLanding,
		name: 'sectors',
	},
    {
        path: '/sectors/add',
        component: SectorAdd,
        name: 'sector-add'
    },
    {
        path: '/sectors/:sector_id(\\d+)',
        component: SectorSingleView,
        name: 'sector-single-view',
        props: route => ({
            id: parseInt(route.params.sector_id),
        })
    },
    {
        path: '/sectors/:sector_id(\\d+)/post/:post_id(\\d+)',
        component: SectorPostView,
        name: 'sector-post-view',
        props: route => ({
            sectorId: parseInt(route.params.sector_id),
            id: parseInt(route.params.post_id),
        })
    },
    {
        path: '/sectors/:sector_id(\\d+)/post/:post_id(\\d+)/edit',
        component: SectorPostEdit,
        name: 'sector-post-edit',
        props: route => ({
            sectorId: parseInt(route.params.sector_id),
            id: parseInt(route.params.post_id),
        })
    },
	{
		path: '/sectors/:sector_id(\\d+)/edit',
		component: SectorEdit,
		name: 'sector-edit',
        props: route => ({
            id: parseInt(route.params.sector_id),
        })
	},
	{
        //TODO Remove
		path: '/sectors/edit',
		component: SectorEditAll,
		name: 'sector-edit-all'
	},
	{
		path: '/sectors/:sector_id(\\d+)/experts',
		component: SectorSpecialists,
		name: 'sector-experts',
		props: route => ({
			id: parseInt(route.params.sector_id),
		})
	},
    {
        path: '/notifications',
        component: NotificationsView,
        name: 'view-notifications'
    },
	{
		path: '/users/create',
		component: UserCreateForm,
		name: 'create-user'
	},
	{
		path: '/users/create/:step([1-5])',
		component: UserCreateForm,
		name: 'create-user-step',
		props: route => ({ step: parseInt(route.params.step) }),
	},
	{
		path: '/users/:tab?',
		component: UserList,
		name: 'users',
		props: route => ({
			tab: route.params.tab,
		}),
	},
	{
		path: '/assume-identity',
		component: UserImpersonate,
		name: 'assume-identity',
	},
	{
		path: '/reports/:tab?',
		component: ReportList,
		name: 'reports',
		props: route => ({
			tab: route.params.tab,
		}),
	},
	{
		path: '/:tab?',
		component: PageDashboard,
		name: 'dashboard',
		props: route => ({
			tab: route.params.tab,
		}),
	},
    {
        path: '/register/event',
        component: PageEvent,
        name: 'london',
        props: route => ({
            tab: route.params.tab,
        })
    },
    {
        path: '/register/thanks',
        component: PageThanks,
        name: 'Thanks',
        props: route => ({
            tab: route.params.tab,
        })
    },
];

const router = new VueRouter({
	mode: 'hash',
	routes: routes,
	scrollBehavior(to, from, savedPosition) {
		if(savedPosition) {
			return savedPosition;
		} else {
			return { x: 0, y: 0 };
		}
	}
});

router.afterEach((to, from) => {
    if(window.gtag) {
        gtag('config', 'UA-120832523-1', {'page_path': to.fullPath});
    }
});

router.beforeEach((to, from, next) => {
	beforeEach(to, from, next);
});

function beforeEach(to, from, next) {
    new PageTitle(to);
	//Redirect to login if logged out
	if(to.meta.requiresLogin !== false) {
		if(!store.state.auth.user) {
			next({
				path: '/login',
				query: {redirect: to.fullPath},
			});

			return;
		}
	}

	//Redirect to dashboard if logged in
	if(to.meta.requiresLogout === true) {
		if(store.state.auth.user) {
			next({
				path: '/dashboard',
			});

			return;
		}
	}

	next();
}

export default router;
